import React, { useEffect, useRef } from "react";
import MusicBtn from "../assets/images/music-btn.svg";
import MuteBtn from "../assets/images/mute-btn.svg";
import Bumbershoot from "../assets/images/audio/Bumbershoot.mp3";

const Audio = () => {
  const audioRef = useRef(null);

  useEffect(() => {
    const playAudio = async () => {
      try {
        await audioRef.current.play();
      } catch (error) {
        console.log("Autoplay prevented: ", error);
      }
    };

    playAudio();
  }, []);

  const audioHandler = () => {
    const musicButton = document.getElementById("toggle-music-btn");
    const musicPlayer = document.getElementById("background-music");

    if (musicPlayer.paused) {
      musicPlayer.play();
      musicButton.innerHTML = `<img src=${MusicBtn} svg" alt="Music button" />`;
      // movingCat.style.display = "block";
      // stillCat.style.display = "none";
    } else {
      musicPlayer.pause();
      musicButton.innerHTML = `<img src=${MuteBtn} alt="Pause music button" />`;
      // movingCat.style.display = "none";
      // stillCat.style.display = "block";
    }
  };

  return (
    <div className="audio-btns">
      <audio ref={audioRef} id="background-music" preload="auto" loop autoPlay>
        <source src={Bumbershoot} type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
      {/* <iframe src="/images/audio/Bumbershoot.mp3" allow="autoplay" frameborder="0"></iframe> */}
      <button id="toggle-music-btn" onClick={audioHandler}>
        <img src={MusicBtn} alt="Music button" />
        {/* <img src="/images/mute-btn.svg" alt="Music button" />*/}
      </button>
    </div>
  );
};

export default Audio;
